export enum AlgoliaEvents {
  INDUSTRIAL_VACANCY_CLICKED = "industrial_vacancy_clicked",
  MICRO_VACANCY_CLICKED = "micro_vacancy_clicked",
  INDIVIDUAL_VACANCY_CLICKED = "individual_vacancy_clicked",
  INDUSTRIAL_VACANCY_APPLIED = "industrial_vacancy_applied",
  MICRO_VACANCY_APPLIED = "micro_vacancy_applied",
  INDIVIDUAL_VACANCY_APPLIED = "individual_vacancy_applied",

  COMPANY_EMPLOYER_CLICKED = "company_employer_clicked",
  GOVERNMENT_EMPLOYER_CLICKED = "government_employer_clicked",
  INDIVIDUAL_EMPLOYER_CLICKED = "individual_employer_clicked",
}